var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "box-card",
          attrs: { shadow: "never", bordered: false },
        },
        [
          _c("div", { staticClass: "tips" }, [
            _vm._v(
              " 这里改的是本账号绑定的门店，与平台「门店管理」是同一份资料，保存后两边同步； app 门店专区展示的门店地址取「详细地址」。门店编号、状态、负责团长由平台设置。 "
            ),
          ]),
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "store-form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "100px",
                size: "small",
              },
            },
            [
              _c("el-form-item", { attrs: { label: "门店编号：" } }, [
                _c("span", [_vm._v(_vm._s(_vm.form.storeNo || "-"))]),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "门店状态：" } },
                [
                  _c(
                    "el-tag",
                    {
                      attrs: {
                        size: "mini",
                        type:
                          Number(_vm.form.status) === 0 ? "success" : "info",
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            Number(_vm.form.status) === 0 ? "正常" : "已停用"
                          ) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c("el-form-item", { attrs: { label: "负责团长：" } }, [
                _c("span", [_vm._v(_vm._s(_vm.form.leaderName || "-"))]),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "签约合同：" } },
                [
                  _vm.form.leaderContractUrl
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "text", size: "small" },
                          on: { click: _vm.previewContract },
                        },
                        [_vm._v("查看合同")]
                      )
                    : _c("span", { staticClass: "contract-none" }, [
                        _vm._v("暂无（团长签约后由平台上传）"),
                      ]),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "门店名称：", prop: "storeName" } },
                [
                  _c("el-input", {
                    attrs: { maxlength: "64", placeholder: "请输入门店名称" },
                    model: {
                      value: _vm.form.storeName,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "storeName",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.storeName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "联系人：" } },
                [
                  _c("el-input", {
                    attrs: { maxlength: "32", placeholder: "请输入联系人姓名" },
                    model: {
                      value: _vm.form.contactName,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "contactName",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.contactName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "联系电话：", prop: "contactPhone" } },
                [
                  _c("el-input", {
                    attrs: { maxlength: "20", placeholder: "请输入联系电话" },
                    model: {
                      value: _vm.form.contactPhone,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "contactPhone",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.contactPhone",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "详细地址：", prop: "address" } },
                [
                  _c("el-input", {
                    attrs: {
                      maxlength: "255",
                      placeholder: "省市区 + 街道门牌，顾客到店核销按这个找",
                    },
                    model: {
                      value: _vm.form.address,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "address",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.address",
                    },
                  }),
                ],
                1
              ),
              _c("el-form-item", { attrs: { label: "门店图片：" } }, [
                _c(
                  "div",
                  { staticClass: "store-images" },
                  [
                    _vm._l(_vm.form.imageList, function (url, idx) {
                      return _c(
                        "div",
                        { key: url + idx, staticClass: "store-image-item" },
                        [
                          _c("img", {
                            staticClass: "store-image",
                            attrs: { src: url },
                          }),
                          _c("i", {
                            staticClass: "el-icon-delete store-image-del",
                            on: {
                              click: function ($event) {
                                return _vm.removeImage(idx)
                              },
                            },
                          }),
                        ]
                      )
                    }),
                    _vm.form.imageList.length < _vm.IMAGE_LIMIT
                      ? _c(
                          "el-upload",
                          {
                            staticClass: "store-image-upload",
                            attrs: {
                              action: "",
                              "http-request": _vm.uploadImage,
                              "show-file-list": false,
                              accept: "image/*",
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "store-image-placeholder" },
                              [_c("i", { staticClass: "el-icon-plus" })]
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  2
                ),
                _c("div", { staticClass: "form-tip" }, [
                  _vm._v(
                    "门头、店内实景等，最多 " +
                      _vm._s(_vm.IMAGE_LIMIT) +
                      " 张，第一张作为封面。"
                  ),
                ]),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "备注：" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 3,
                      maxlength: "255",
                      placeholder: "选填",
                    },
                    model: {
                      value: _vm.form.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "remark", $$v)
                      },
                      expression: "form.remark",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", loading: _vm.saving },
                      on: { click: _vm.submit },
                    },
                    [_vm._v("保存")]
                  ),
                  _c("el-button", { on: { click: _vm.load } }, [
                    _vm._v("重置"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "签约合同",
            visible: _vm.contractVisible,
            width: "80%",
            top: "4vh",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.contractVisible = $event
            },
            closed: _vm.revokeContract,
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.contractLoading,
                  expression: "contractLoading",
                },
              ],
              staticClass: "contract-box",
            },
            [
              _vm.contractBlobUrl
                ? _c("iframe", {
                    staticClass: "contract-frame",
                    attrs: { src: _vm.contractBlobUrl },
                  })
                : _vm.contractError
                ? _c("div", { staticClass: "contract-error" }, [
                    _vm._v(_vm._s(_vm.contractError)),
                  ])
                : _vm._e(),
            ]
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: { click: _vm.openContractNew },
                },
                [_vm._v("新窗口打开")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.contractVisible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }